import { Home, ClipboardList, UtensilsCrossed, Heart, BarChart3, AlertTriangle, Plug, GraduationCap, MessageSquare, FolderOpen, Briefcase, FileText, Users, Tablet, Globe, Shirt, Shield, Target, Wifi, Droplets, TreePine, Trophy, Baby, Award, Building2, BookOpen, Landmark, HandHeart } from 'lucide-react';

const ALL = ['teacher', 'principal', 'district', 'moe'];
const ADMIN = ['principal', 'district', 'moe'];
const SENIOR = ['district', 'moe'];

export const NAV_GROUPS = [
  { id: 'core', en: 'Daily Work', bn: 'দৈনন্দিন কাজ', items: [
    { path: '/', icon: Home, en: 'Home', bn: 'হোম', roles: ALL },
    { path: '/governance', icon: BarChart3, en: 'Governance', bn: 'প্রশাসন', roles: ADMIN },
    { path: '/manifesto', icon: Target, en: 'Manifesto Tracker', bn: 'ইশতেহার ট্র্যাকার', roles: ADMIN },
    { path: '/attendance', icon: ClipboardList, en: 'Attendance', bn: 'হাজিরা', roles: ALL },
    { path: '/meals', icon: UtensilsCrossed, en: 'Mid-Day Meals', bn: 'মিড-ডে মিল', roles: ALL },
    { path: '/grades', icon: FileText, en: 'Grades & Report Card', bn: 'ফলাফল ও রিপোর্ট কার্ড', roles: ALL },
    { path: '/incidents', icon: AlertTriangle, en: 'Student Portfolio', bn: 'শিক্ষার্থী পোর্টফোলিও', roles: ALL },
    { path: '/communication', icon: MessageSquare, en: 'Communication', bn: 'যোগাযোগ', roles: ALL },
    { path: '/health', icon: Heart, en: 'Health & Wellness', bn: 'স্বাস্থ্য ও সুস্থতা', roles: ['teacher', 'principal'] },
  ] },
  { id: 'p1', en: 'Infrastructure', bn: 'অবকাঠামো', pillar: 1, items: [
    { path: '/infrastructure', icon: Wifi, en: 'Wi-Fi, Multimedia & Budget', bn: 'ওয়াই-ফাই, মাল্টিমিডিয়া ও বাজেট', roles: ALL },
    { path: '/facilities', icon: Droplets, en: 'Toilets & Vending', bn: 'টয়লেট ও ভেন্ডিং', roles: ALL },
    { path: '/tablets', icon: Tablet, en: 'OTOT Tablets', bn: 'ওটিওটি ট্যাবলেট', roles: ADMIN },
  ] },
  { id: 'p2', en: 'Primary & Secondary', bn: 'প্রাথমিক ও মাধ্যমিক', pillar: 2, items: [
    { path: '/uniforms', icon: Shirt, en: 'Free School Dress', bn: 'বিনামূল্যে স্কুল ড্রেস', roles: ALL },
    { path: '/pre-primary', icon: Baby, en: 'Pre-Primary', bn: 'প্রাক-প্রাথমিক', roles: ALL },
    { path: '/third-language', icon: Globe, en: 'Third Language', bn: 'তৃতীয় ভাষা', roles: ALL },
    { path: '/green', icon: TreePine, en: 'One Child, One Tree', bn: 'এক শিশু, এক গাছ', roles: ALL },
    { path: '/talent', icon: Trophy, en: 'Sports, Culture & Talent', bn: 'খেলাধুলা, সংস্কৃতি ও প্রতিভা', roles: ALL },
  ] },
  { id: 'p3', en: 'Higher Education', bn: 'উচ্চশিক্ষা', pillar: 3, items: [
    { path: '/scholarships', icon: Award, en: 'Grants, Loans & Scholarships', bn: 'অনুদান, ঋণ ও বৃত্তি', roles: ALL },
    { path: '/internships', icon: Building2, en: 'Internships & Industry', bn: 'ইন্টার্নশিপ ও শিল্প', roles: ALL },
    { path: '/career', icon: Briefcase, en: 'Career & Conclave', bn: 'ক্যারিয়ার ও কনক্লেভ', roles: ALL },
    { path: '/alumni', icon: Users, en: 'Alumni Network', bn: 'প্রাক্তন শিক্ষার্থী', roles: ALL },
  ] },
  { id: 'p4', en: 'Madrasa & Technical', bn: 'মাদ্রাসা ও কারিগরি', pillar: 4, items: [
    { path: '/madrasa-tvet', icon: Landmark, en: 'Madrasa & TVET', bn: 'মাদ্রাসা ও কারিগরি শিক্ষা', roles: ALL },
  ] },
  { id: 'p5', en: 'Teachers & Reform', bn: 'শিক্ষক ও সংস্কার', pillar: 5, items: [
    { path: '/lms', icon: GraduationCap, en: 'My Learning (CPD)', bn: 'আমার শিখন (CPD)', roles: ALL },
    { path: '/resource-hub', icon: FolderOpen, en: 'Resource Hub', bn: 'রিসোর্স হাব', roles: ALL },
    { path: '/reform', icon: BookOpen, en: 'Reform Commission', bn: 'সংস্কার কমিশন', roles: ALL },
    { path: '/teacher-welfare', icon: HandHeart, en: 'Teacher Welfare & Honours', bn: 'শিক্ষক কল্যাণ ও সম্মাননা', roles: ALL },
    { path: '/martyrs', icon: Shield, en: 'July Martyrs & Injured', bn: 'জুলাই শহীদ ও আহত', roles: ALL },
    { path: '/integrations', icon: Plug, en: 'Integrations', bn: 'সরকারি সংযোগ', roles: SENIOR },
  ] },
];

export const findNav = path => NAV_GROUPS.flatMap(g => g.items).find(i => i.path === path);
